import { useEffect, useState } from 'react';
import {
  Box,
  TextareaAutosize,
  Button,
} from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { useApi } from '@bumble/app/hooks/use-api';
import { toast } from 'react-toastify';
import { Loading } from '../Loading';
import { apiError } from '@bumble/app/utils/api-error';

interface RouterGetDiagnosticProps {
  cpeId: string;
  onSubmit: () => void;
}

export const RouterGetDiagnostic = ({ cpeId,  onSubmit }: RouterGetDiagnosticProps) => {

  const [result, setResult] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  let isCalled = false;
  const api = useApi();

  const getDiagnostic = useMutation(api.runHealthCheckApiV1RunHealthCheckGet, {
    onSuccess: (res) => {
      const parsedData = JSON.parse(res.data);
      setResult(JSON.stringify(parsedData, null, 2));
      setIsLoading(false);
      toast.success('Get diagnostics successfully.');
    },
    onError(error: any) {
      setIsLoading(false);
      apiError(error);
    },
  });

  const handleSubmit = () => {
    onSubmit();
  };

  useEffect(() => {
    if (cpeId) {
      setIsLoading(true);
      !isCalled && getDiagnostic.mutate({node_id: cpeId});
      isCalled = true;
    }
  }, [cpeId]);

  return (
    <Box pt={2}>
      {isLoading ? <Loading />:
        <TextareaAutosize
          style={{ width: '100%' }}
          minRows={15}
          value={result}
          readOnly
        />
      }
      <Box display="flex" justifyContent="flex-end" sx={{ mt: 5 }}>
        <Button variant="outlined" onClick={handleSubmit}>
          Close
        </Button>
      </Box>
    </Box>
  );
};
